
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hand-sanitizer-disposal",
      function () {
        return require("private-next-pages/hand-sanitizer-disposal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hand-sanitizer-disposal"])
      });
    }
  